
const GOOGLE_USER_INFO = 'https://www.googleapis.com/oauth2/v1/userinfo?alt=json';
class GoogleService {
    async getProfileImageUrl(userToken: string) {
        const response = await fetch(`${GOOGLE_USER_INFO}`, {
            headers: {
                Authorization: `Bearer ${userToken}`,
            },
        });
        if (!response.ok) {
            return Promise.reject(new Error('Failed to fetch Google profile image'));
        }
        const data = await response.json();
        return data.picture ? data.picture : Promise.reject(new Error('Google profile image not found'));
    }
}

export default new GoogleService();